import { Link } from "react-router-dom";
import { Badge, Box, Button, ButtonGroup, Flex, HStack, Stack, Text } from "@chakra-ui/react";
import { Trans } from "@lingui/react/macro";

import { SensorDataTrigger } from "../types/alarmInterface";

interface ConfiguredSensorAlarmCardProps {
  trigger: SensorDataTrigger;
  onDelete?: (trigger: SensorDataTrigger) => void;
}

const ConfiguredSensorAlarmCard = ({ trigger, onDelete }: ConfiguredSensorAlarmCardProps) => (
  <Box borderWidth="1px" borderRadius={6} p={4} bgColor="white">
    <Flex justify="space-between" gap={4} wrap="wrap">
      <Stack spacing={1}>
        <HStack>
          <Badge colorScheme={trigger.is_enabled ? "green" : "gray"}>
            {trigger.is_enabled ? <Trans>Enabled</Trans> : <Trans>Disabled</Trans>}
          </Badge>
          <Badge colorScheme={"gray"}>
            <Trans>Sensor</Trans>
          </Badge>

          <Badge colorScheme={"gray"}>{trigger.severity}</Badge>
        </HStack>
        <Text fontWeight="semibold">{trigger.device_name}</Text>
        <Text>
          {trigger.metric.replaceAll("_", " ")} {trigger.comparison_direction.toLowerCase()}{" "}
          {trigger.trigger_value}
        </Text>
        <Text fontSize="sm" color="gray.600">
          {trigger.notification_channels.join(", ")}
        </Text>
      </Stack>
      <ButtonGroup
        size="sm"
        alignSelf="start"
        flexDirection={{ base: "column", md: "row" }}
        w={{ base: "full", md: "auto" }}
      >
        <Button as={Link} to={`/alarms/edit/${trigger.id}`} w={{ base: "full", md: "auto" }}>
          <Trans>Edit</Trans>
        </Button>
        {onDelete && (
          <Button
            colorScheme="red"
            variant="outline"
            onClick={() => onDelete(trigger)}
            w={{ base: "full", md: "auto" }}
          >
            <Trans>Delete</Trans>
          </Button>
        )}
      </ButtonGroup>
    </Flex>
  </Box>
);

export default ConfiguredSensorAlarmCard;
